export default __webpack_public_path__ + "static/media/nodeJS.615ffbea.svg";